import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Logger } from '../../shared/logger';
import { ErrorMessages } from '../../shared/error/error-messages';
import { Equipo } from '../models';
import { Observable } from 'rxjs';
import { QueryBuilder } from '../query';
import { map } from 'rxjs/operators';
import { arrayUnion, Timestamp } from 'firebase/firestore';

@Injectable()
export class EquiposService extends RestService<Equipo> {

    constructor(
        protected errorMessages: ErrorMessages,
        protected afAuth: AngularFireAuth,
        protected store: AngularFirestore,
        protected logger: Logger
    ) {
        super(errorMessages, afAuth, store, logger, 'equipos');
    }

    getEquipoByMatricula(matricula: string) {
        let builder = QueryBuilder.new();
        builder.where('matricula', '==', matricula);
        builder.limit(1);
        let options = builder.build();
        return this.allWith(options).pipe(
            map((res:any)=>{
               if (res && Array.isArray(res)) 
                  return res[0]   
               return res; 
            }))
    }

    getEquipos(): Observable<any> {
        let builder = QueryBuilder.new();
        builder.orderBy('matricula', 'asc');
        builder.where('habilitado', '==', 1);
        builder.limit(100);
        let options = builder.build();
        return this.allWith(options);
    }

    async updateHorimetro(
        equipo: Equipo,
        parteDiarioId: string,
        changes: Partial<Equipo> & { horimetro?: string }
    ) {
        if (!equipo) return;

        const now = Timestamp.now();

        // Construyo el payload de cambios sobre el equipo
        const updatePayload: any = {
            ...equipo,
            ...changes,
        };

        // Si se actualizó horimetro, guardo el histórico en subcolección
        if (changes.horimetro) {
            const historicoEntry = {
                created_at: now,
                parteDiarioId,
                horimetro: changes.horimetro,
            };

            await this.store
                .collection('equipos')
                .doc(equipo.id)
                .collection('historico')
                .add(historicoEntry);
        }
        // Actualizo el documento principal
        return this.update(updatePayload);

    }

    /**
     * Controla que el horímetro ingresado sea válido
     */
    controlHorimetro(equipo: Equipo, nuevoHorimetro: number): { status: 'ok' | 'alert'; message?: string } {
        if (!equipo?.horimetro) {
            return { status: 'ok' }; // no hay histórico, no se controla
        }
        const ultimoHorimetro = parseInt(equipo.horimetro as any, 10);

        // 1) Si el último horímetro es mayor
        if (ultimoHorimetro > nuevoHorimetro) {
            return {
                status: 'alert',
                message: `Estimado, ingresó horímetro de equipo ${equipo.matricula} de ${nuevoHorimetro}. Último horímetro seteado para el equipo: ${ultimoHorimetro}. ¿Continuar?`,
            };
        }

        // 2) Si el nuevo horimetro - el último horímetro es  mayor a 24
        if ((nuevoHorimetro - ultimoHorimetro) > 24) {
            return {
                status: 'alert',
                message: `Estimado, ingresó horímetro de equipo ${equipo.matricula} de ${nuevoHorimetro}. Último horímetro seteado para el equipo: ${ultimoHorimetro}. ¿Continuar?`,
            };
        }

        // 3) Todo ok
        return { status: 'ok' };
    }

}
